<template>


  <div class="search-wrapper active" :class="{'actived':actived}">

<!--    <div class="input-holder">
      <input ref="search_input" @focus="actived = true" @blur="actived = false" v-model="inputSearch" type="text"
             class="search-input">
      <i class="input-icon pe-7s-search"></i>
    </div>-->

  </div>

</template>

<script>
export default {
  name: "t-app-header-search-button",
  data() {
    return {
      actived: false,
      inputSearch: ""
    }
  },
  computed: {
    searchOpened() {
      return this.opended
    }
  },
  methods: {
    search() {
      if (this.inputSearch.length > 1) {
        this.opended = true;
      } else {
        this.opended = true;
        this.$refs.search_input.focus();
      }
    },
    close() {
      this.opended = false;
    }
  }


}
</script>

<style scoped>
.input-holder .input-icon {
  font-size: 20px;
  position: absolute;
  right: 10px;
  bottom: 9px;
  color: #ccc;
}

.actived .input-holder {
  border-color: #6989f5 !important;
}

.actived .input-icon {
  color: #6989f5;
}
</style>
